import './polyfills';
import React from 'react';
import './index.css';
import reportWebVitals from './reportWebVitals';
import ReactDOM from 'react-dom/client';
import App from "./App";
import {BrowserRouter} from "react-router-dom";
import store from "./redux/redux-store.js";
import {Provider} from "react-redux";
import '@ant-design/v5-patch-for-react-19';
import UpdateBanner from "./components/UpdateBanner";

class ResizeObserverErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error) {
        if (error.toString().includes('ResizeObserver')) {
            return {hasError: true};
        }
        throw error;
    }

    componentDidCatch(error, errorInfo) {
        if (error.toString().includes('ResizeObserver')) {
            console.log('ResizeObserver error caught and suppressed');
            return;
        }
        console.error('Uncaught error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback || this.props.children;
        }
        return this.props.children;
    }
}

export default ResizeObserverErrorBoundary;

const ignoreResizeObserverError = () => {
    const originalError = console.error;

    if (window.ignoreResizeObserverError) return;
    window.ignoreResizeObserverError = true;

    console.error = (...args) => {
        if (typeof args[0] === 'string' && args[0].includes('ResizeObserver')) {
            return;
        }
        originalError.apply(console, args);
    };

    window.addEventListener('error', (e) => {
        if (e.message.includes('ResizeObserver')) {
            e.stopImmediatePropagation();
        }
    });
};

ignoreResizeObserverError();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<BrowserRouter>
    <Provider store={store}>
        <ResizeObserverErrorBoundary>
            <UpdateBanner/>
            <App store={store}/>
        </ResizeObserverErrorBoundary>
    </Provider>
</BrowserRouter>);


reportWebVitals();




